import { PREFIX } from '../common/constants';

export const PHONELOGINTABKEY = `${PREFIX}_PHONE_LOGIN`;
export const ACCOUNTLOGINTABKEY = `${PREFIX}_ACCOUNT_LOGIN`;
export const SCANLOGINTABKEY = `${PREFIX}_SCAN_LOGIN`;

export const ACCOUNT_KEY = {
  mobileCode: '@kc/entrance.mobileCode',
  [PHONELOGINTABKEY]: '@kc/entrance.phone',
  [ACCOUNTLOGINTABKEY]: '@kc/entrance.account',
  [SCANLOGINTABKEY]: '',
};

export const SCAN_WAITING = 'waiting'; // 等待扫码

export const SCAN_AUTHORIZED = 'authorized'; // app已确认登录

export const SCAN_SCANNED = 'scanned'; // app已扫码

export const SCAN_EXPIRED = 'expired'; // 不存在或过期

export const SCAN_CANCELED = 'canceled'; // app取消登录

export const NAMESPACE = '$entrance_signIn';
// 风险标识
export const RISK_TAG = {
  LOGIN_RISK_SMS_VERIFY: {
    warnText: 'fBZ1R8WHZd7ct59pcxZSJy',
  },
  LOGIN_RISK_EMAIL_VERIFY: {},
};
